export enum ROLES {
  SUPERADMIN = 1,
  ADMIN = 2,
  USER = 3,
}
